import { FC } from 'react';

import { PriceProps } from 'components/Price';
import RebrandedPrice from 'components/Price/rebranded';

type PlanPriceProps = Pick<PriceProps, 'value' | 'withoutCents'>;
const PlanPrice: FC<PlanPriceProps> = (props) => <RebrandedPrice {...props} />;

export default PlanPrice;
